import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useHomeStore from '../store/cmsStore/homeStore';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import secureDataIcon from '../assets/images/secure_data_icon.png';
import communityModerationIcon from '../assets/images/community_moderation_icon.png';
import emailIcon from '../assets/images/email_icon.png';
import testimonialFallback from '../assets/images/testimonial_3.png';
import Skeleton from 'react-loading-skeleton'
import Seo from '../components/Seo';
//import 'react-loading-skeleton/dist/skeleton.css'


//import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';

// init Swiper:


const Home: React.FC = () => {
  const { sections, fetchSectionsList } = useHomeStore();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Listen for window resize to update the isMobile state
  useEffect(() => {

      if ("Notification" in window) {
            if (Notification.permission !== "granted") {
            Notification.requestPermission().then(permission => {
                if (permission !== "granted") {
                console.log("Notifications blocked by user.");
                }
            });
            }
        } else {
            console.log("Notifications are not supported on this device/browser.");
        }

    window.scrollTo(0, 0);
    console.log(window.innerWidth);
    console.log(isMobile);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    fetchSectionsList();

  }, [fetchSectionsList]);


// Select the appropriate section based on screen size
const heroSection = isMobile ? sections.hero_section_mobile : sections.hero_section;

  return (
    <>
        <Seo
          title="Meet Real Singles on SLAMMMM | Free to Join"
          description="Tired of endless swiping? SLAMMMM connects single ladies and men looking for real relationships. Meet genuine matches and mingle today. Sign up now!"
        />
         {heroSection?.loaded ? (
        // ✅ Show real content once loaded
        <section
          className="hero_section"
          style={{
            backgroundImage: `url(${heroSection.payload.field_1?.value || ""})`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-7 col-md-8">
                <div className="hero_caption">
                  <h1>{heroSection.payload.field_2?.value || ""}</h1>
                  <p>{heroSection.payload.field_3?.value || ""}</p>
                  <Link to={sections.hero_section.payload.field_4?.link || "#"}>
                    <button className="btn btn-primary">
                      {sections.hero_section.payload.field_4?.value || "Learn More"}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        // 🔄 Show Skeleton Loader while fetching data
        <section className="hero_section skeleton">
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-7 col-md-8">
                <div className="hero_caption">
                  <h1>
                    <Skeleton width={300} height={40} enableAnimation />
                  </h1>
                  <p>
                    <Skeleton count={2} width={250} enableAnimation />
                  </p>
                  <Skeleton width={120} height={40} style={{ borderRadius: "5px" }} enableAnimation />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {sections.why_choose_section?.loaded && (
          <section className="py-100 why_choose_section bg-light">
              <div className="container">
                  <div className="row">
                      <div className="col-lg-3">
                          <div className="script_heading mb-4">
                              <h2>Where</h2>
                          </div>
                          <div className="why_choose_left_title">
                              <h3><span className="first change">S</span>ingle </h3>
                              <h3><span className="first change1">L</span>adies </h3>
                              <h3><span className="first change2">A</span>nd </h3>
                              <h3><span className="first change3">M</span>en </h3>
                              <h3><span className="first change4">M</span>ix </h3>
                              <h3><span className="first change5">M</span>ingle & </h3>
                              <h3><span className="first change6">M</span>arry <sub>TM</sub></h3>


                          </div>
                      </div>
                      <div className="col-lg-9 pl-md-0">
                          <div className="section_title">
                          <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: sections.why_choose_section.payload.field_1.value }}></h2>
                          </div>
                          <p className="font18 mb-4">{sections.why_choose_section.payload.field_2.value}

                          </p>
                          <Link to={sections.why_choose_section.payload.field_3.link || '#'}>
                          <button className="btn btn-outline-primary">{sections.why_choose_section.payload.field_3.value}</button></Link>
                          <div className="why_choose_howitwork">
                              <h4><span>How It Works.</span></h4>
                              <div className="section_title">
                                <h2 className="mb-4 bs-font-script text-container">
                                    Try our Patented  <Link to="/features" className="highlight">Love Diamond <sub>TM</sub></Link>

                                    {/* <div className="highlight-wrapper">
                                                <Link to="/features" className="highlight">Love Diamond</Link>
                                                <svg className="ellipse ellipse-svg" viewBox="0 0 220 60" height="90">
                                                    <ellipse cx="110" cy="30" rx="100" ry="22" />
                                                </svg>
                                                </div> */}

                                      Feature!</h2>
                                    </div>
                              <div className="row">


                                  <div className="col-md-12">
                                      <div className="card">
                                          <div className="why_howit_icon mb-4">
                                              <img src={sections.why_choose_section.payload.field_4.value} alt="" className="img-fluid" />
                                          </div>
                                          <h3>{sections.why_choose_section.payload.field_5.value}</h3>
                                              <p className="font17 mb-0 mt-1" dangerouslySetInnerHTML={{ __html: sections.why_choose_section.payload.field_6.value }}>
                                              </p>
                                      </div>
                                  </div>
                                  {/* <div className="col-md-6">
                                      <div className="card">
                                          <div className="why_howit_icon mb-4">
                                              <img src="./assets/images/howit_icon2.png" alt="" className="img-fluid" />
                                          </div>
                                          <h3>Connect Meaningfully</h3>
                                              <p className="font17 mb-0 mt-1">Engage in authentic conversations with people who
                                                  resonate with you.
                                              </p>
                                      </div>
                                  </div> */}
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
          </section>
          )}
           {sections.our_features?.loaded && (
          <section className="py-100 our_unique_features">
                  <div className="container">
                      <div className="row">
                          <div className="col-lg-4 pe-5">
                              <div className="section_title border-bottom mb-4">
                                  <h2 className="mb-4">{sections.our_features.payload.field_1.value} <br/></h2>
                              </div>
                              <p className="font20 mb-4">{sections.our_features.payload.field_2.value}
                              </p>
                              <Link to={sections.our_features.payload.field_3.link || '#'}>
                              <button className="btn btn-outline-primary mb-4 mb-lg-0" >{sections.our_features.payload.field_3.value}</button></Link>
                          </div>
                          <div className="col-lg-8">
                    <div className="row g-4">
                        <div className="col-lg-12">
                            <Link to="/features#love_diamond" className="unique_features_link">
                                <div className="unique_features_box unique_features_box1">
                                    <div className="image_box_overlay">
                                        <img src={sections.our_features.payload.field_4.value} alt="" className="img-fluid" />
                                    </div>
                                    <div className="features_box_cnt">
                                        <div className="">
                                            <h3>{sections.our_features.payload.field_5.value}<sub>TM</sub></h3>
                                            <p>{sections.our_features.payload.field_6.value}</p>
                                        </div>
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-6">
                            <Link to="/features#genre_matching" className="unique_features_link">
                                <div className="unique_features_box unique_features_box2">
                                    <div className="image_box_overlay">
                                        <img src={sections.our_features.payload.field_7.value} alt="" className="img-fluid" />
                                    </div>
                                    <div className="features_box_cnt">
                                        <div className="">
                                            <h3>{sections.our_features.payload.field_8.value}</h3>
                                            <p>{sections.our_features.payload.field_9.value}</p>
                                        </div>
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-6">
                            <Link to="/features#send_likes" className="unique_features_link">
                                <div className="unique_features_box unique_features_box2">
                                    <div className="image_box_overlay">
                                        <img src={sections.our_features.payload.field_10.value} alt="" className="img-fluid" />
                                    </div>
                                    <div className="features_box_cnt">
                                        <div className="">
                                            <h3>{sections.our_features.payload.field_11.value}</h3>
                                            <p>{sections.our_features.payload.field_12.value}</p>
                                        </div>
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                      </div>
                  </div>
              </section>
             )}

            {sections.testimonials?.loaded && (
            <section className="py-100 bg-secondary testimonial_section ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section_title mb-5 text-center">
                                <h2 className="mb-0 text-white">{sections.testimonials.payload.field_1.value}</h2>
                            </div>
                            <div className="testimonial_slide_container swiper swiper2 pt-2 testimonial_slide_content mx-0">


                                        <Swiper
                                        className='testimonial_slide_content'
                                        modules={[Navigation, Pagination, Autoplay]}
                                        spaceBetween={30}
                                        slidesPerView={1}
                                        navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                        }}
                                        pagination={{ clickable: true }}
                                        autoplay={{ delay: 3000 }}
                                        loop={true}
                                    >
                                        {sections.testimonials.loop_fields.map((testimonial, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="testimonial_card">
                                            <div className="row align-items-center">
                                                <div className="col-md-6">
                                                <div className="testimonial_card_cnt">
                                                    <h3>{testimonial.title}</h3>
                                                    <p>{testimonial.description}</p>
                                                </div>
                                                </div>
                                                <div className="col-md-6">
                                                <div className="testimonial_card_img">
                                                    <img
                                                    src={testimonial.image}
                                                    alt={testimonial.title}
                                                    className="img-fluid"
                                                    onError={(event) => {
                                                        event.currentTarget.onerror = null;
                                                        event.currentTarget.src = testimonialFallback;
                                                    }}
                                                    />
                                                    <div className="testimonial_story_cta">
                                                        <Link to="/love-stories" className="btn btn-primary testimonial_story_button">
                                                            Slammmm Love Stories
                                                        </Link>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
                                    <div className="swiper-button-prev">
                                        <i className="fa-solid fa-arrow-left"></i>
                                    </div>
                                    <div className="swiper-button-next">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
             )}

            {sections.your_saftey?.loaded && (
            <section className="py-100 you_safety_priority bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-5">
                            <div className="section_title mb-4">
                                <h2 className="mb-4">{sections.your_saftey.payload.field_1.value} <br/></h2>
                            </div>

                        </div>
                        <div className="col-lg-8">
                            <p className="font18 mb-4">{sections.your_saftey.payload.field_2.value}
                            </p>
                           <Link to={sections.your_saftey.payload.field_3.link || '#'} ><button className="btn btn-outline-primary">{sections.your_saftey.payload.field_3.value}</button></Link>
                        </div>
                    </div>
                    <div className=" pt-100 mt-0">
                        <div className="row g-3">
                            <div className="col-sm-6 col-lg-4">
                                <div className="card">
                                    <div className="why_howit_icon mb-4">
                                        <img src={secureDataIcon} alt="" className="img-fluid" />
                                    </div>
                                    <h3>{sections.your_saftey.payload.field_4.value}</h3>
                                        <p className="font17 mb-0 mt-1">{sections.your_saftey.payload.field_5.value}
                                        </p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4">
                                <div className="card">
                                    <div className="why_howit_icon mb-4">
                                        <img src={communityModerationIcon} alt="" className="img-fluid" />
                                    </div>
                                    <h3>{sections.your_saftey.payload.field_6.value}</h3>
                                        <p className="font17 mb-0 mt-1">{sections.your_saftey.payload.field_7.value}
                                        </p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4">
                            <a href="mailto:slammmm.com@gmail.com" className="text-decoration-none">
                                <div className="card">
                                    <div className="why_howit_icon mb-4">
                                        <img src={emailIcon} alt="" className="img-fluid" />
                                    </div>
                                    <h3>{sections.your_saftey.payload.field_8.value}</h3>
                                        <p className="font17 mb-0 mt-1">{sections.your_saftey.payload.field_9.value}
                                        </p>
                                        <p className="font17 mb-0 mt-1 text-decoration-underline">slammmm.com@gmail.com</p>
                                        <p className="font17 mb-0 mt-1">15-651-9268</p>
                                        <p className="font17 mb-0 mt-1">610-259-3335</p>
                                </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
             )}

    </>
  );
};

export default Home;